import * as React from "react";

function Layout() {
  return <p>Layout is working!</p>
}

export default Layout;